import React from 'react';
import '../Components/css/whatWeSolve.css'
export default function WhatWeSolve({ story }) {
    const impactWithheld = story?.impact === '';
    return (
        <div className='whatWeSolveBanner'>
            <div className='container'>
                <h2>What we solved</h2>
                <div className={impactWithheld ? 'whatwesolveSection whatwesolveSection--without-impact' : 'whatwesolveSection'}>
                    <div className='what-weSolvedCard'>
                        <div className='what-we-solve-heading'>
                            <p >INDUSTRY</p>
                            <p style={{fontWeight:'600'}}>{story?.industry || 'Industry info not available'}</p>
                        </div>
                        <p className=''     dangerouslySetInnerHTML={{
					__html: story?.description || ""
				}}/>
                            {/* {story?.description || 'Description not available.'} */}
                        
                        {/* </p> */}
                    </div>
                    {!impactWithheld && <div className='what-weSolvedCard'>
                        <div className='what-we-solve-heading'>
                            <p >IMPACT</p>
                        </div>
                        <div className=''>
                            <p>
                                {story?.impact || 'Impact details not available.'}
                            </p>
                        </div>
                    </div>}
                    <div className='what-weSolvedCard'>
                        <div className='what-we-solve-heading'>
                            <p >KEY TECHNOLOGY / PLATFORMS</p>
                        </div>
                        <ul className=''>
                            {(story?.techonolgyStack && story.techonolgyStack.length > 0) ? (
                                story.techonolgyStack.map(tech => (
                                    <li key={tech.id}>{tech.name || 'Unknown Technology'}</li>
                                ))
                            ) : (
                                <li>No technology stack information available.</li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
